import React, { useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

// styles
import { WrapHeader } from './index.styles'

// images
import LogoFacepay from '../../../assets/images/LogoFacepay'
import IcUser from '../../../assets/images/IcUser'
import IcLogOut from '../../../assets/images/IcLogOut'

//hook
import { useOnClickOutside } from '../../../hook/useClickOutside'

// constant
import { MAIN } from '../../../constant/path'

//action
import { logoutAction } from '../../../redux/login/action'

const Header = (props) => {

    const dispatch = useDispatch()
    const history = useHistory()
    const refDropdown = useRef(null)

    const [isShow, setIsShow] = useState(false)

    useOnClickOutside(refDropdown, () => {
        setIsShow(false)
    })

    const _handleLogOut = () => {
        dispatch(logoutAction(history, true))
    }
    return (
        <WrapHeader {...props} ref={refDropdown}>
            <div className='wrap-header'>
                <Link to={`/${MAIN}`} className="logo-facepay">
                    <LogoFacepay />
                </Link>
                <div className="user">
                    <p className="user_name">TP Account 01</p>
                    <IcUser onClick={() => setIsShow(!isShow)} />
                    {
                        isShow &&
                        <div className="popup-logout" onClick={_handleLogOut}>
                            <IcLogOut />
                            <p>Sign out</p>
                        </div>
                    }
                </div>
            </div>
        </WrapHeader>
    )
}

export default Header
